import { useContext, useEffect, useMemo, useRef } from "react";
import { AppContext } from "./App.context";
import { GA_MEASUREMENT_IDS } from "../gaConfig";
import {
  initAnalytics,
  setDefaultParams,
  logAnalyticEvent,
} from "../analytics";

export default function AnalyticsProvider({ children }) {
  const app = useContext(AppContext);

  const initializedRef = useRef(false);

  const ctx = useMemo(() => {
    return {
      tenant: app?.tenant,
      channel: app?.channel,
      product: app?.product,
      journey: app?.customPath,
      language: app?.selectedLanguage?.label,
    };
  }, [
    app?.tenant,
    app?.channel,
    app?.product,
    app?.customPath,
    app?.selectedLanguage,
  ]);

  const getDeviceInfo = () => {
    return {
      device_id: localStorage.getItem("device_id") || generateDeviceId(),
      device_category: navigator.userAgent.includes("Mobi")
        ? "mobile"
        : "desktop",
      device_browser: navigator.userAgent,
      device_os: navigator.platform,
      device_screen_resolution: `${window.screen.width}x${window.screen.height}`,
    };
  };

  const generateDeviceId = () => {
    const deviceId = `udid_${Math.random().toString(36).substr(2, 9)}_${Date.now()}`;
    localStorage.setItem("device_udid", deviceId);
    return deviceId;
  };

  useEffect(() => {
    if (initializedRef.current) return;
    if (!ctx.product) return;
    const measurementId = GA_MEASUREMENT_IDS[ctx.product];

    (async () => {
      const ok = await initAnalytics(measurementId);
      if (!ok) return;

      setDefaultParams({
        tenant: ctx.tenant,
        channel: ctx.channel,
        product: ctx.product,
        journey: ctx.journey,
        selected_language: ctx.language,
        ...getDeviceInfo(),
      });

      initializedRef.current = true;
    })();
  }, [ctx]);

  return children;
}
